module.exports = __webpack_public_path__ + "e11.no2.76b254bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e11.no2.jpg
// module id = IaBr
// module chunks = 0